"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleDocumentField = void 0;
const document_1 = require("../enums/document");
const cpf_1 = require("../helpers/documents/cpf");
const cnpj_1 = require("../helpers/documents/cnpj");
const ci_1 = require("../helpers/documents/ci");
const rut_1 = require("../helpers/documents/rut");
const genericDocument_1 = require("../helpers/documents/genericDocument");
const handleDocumentField = ({ value, name, options, context }) => {
    if (options.document) {
        switch (options.document.type) {
            case document_1.AvailableDocumentHandlers.CPF:
                return handleCpfDocumentField({ value, name, options, context });
            case document_1.AvailableDocumentHandlers.CNPJ:
                return handleCnpjDocumentField({ value, name, options, context });
            case document_1.AvailableDocumentHandlers.CI:
                return handleCiDocumentField({ value, name, options, context });
            case document_1.AvailableDocumentHandlers.RUT:
                return handleRutDocumentField({ value, name, options, context });
            default:
                return handleGenericDocumentField({ value, name, options, context });
        }
    }
    return true;
};
exports.handleDocumentField = handleDocumentField;
const handleCpfDocumentField = ({ value, name, options, context }) => {
    if ((0, cpf_1.validateCpf)(value)) {
        context.actions?.clearError(name);
        return true;
    }
    context.actions?.setError(name, { message: options.document.message });
    return false;
};
const handleCnpjDocumentField = ({ value, name, options, context }) => {
    if ((0, cnpj_1.validateCnpj)(value)) {
        context.actions?.clearError(name);
        return true;
    }
    context.actions?.setError(name, { message: options.document.message });
    return false;
};
const handleCiDocumentField = ({ value, name, options, context }) => {
    if ((0, ci_1.validateCi)(value)) {
        context.actions?.clearError(name);
        return true;
    }
    context.actions?.setError(name, { message: options.document.message });
    return false;
};
const handleRutDocumentField = ({ value, name, options, context }) => {
    if ((0, rut_1.validateRut)(value)) {
        context.actions?.clearError(name);
        return true;
    }
    context.actions?.setError(name, { message: options.document.message });
    return false;
};
const handleGenericDocumentField = ({ value, name, options, context }) => {
    if ((0, genericDocument_1.validateDocument)(value)) {
        context.actions?.clearError(name);
        return true;
    }
    context.actions?.setError(name, { message: options.document.message });
    return false;
};
